import { FOOTER_LINKS } from './externalUrls';

import { HELP_ARTICLES } from '@/constants/helpUrls.ts';

export const secondaryNavigation = [
  {
    title: 'Blog',
    link: FOOTER_LINKS.BLOG_LINK,
    external: true,
    translation: 'Nav.Blog',
    rel: 'noopener',
  },
  {
    title: 'About',
    link: FOOTER_LINKS.ABOUT_LINK,
    external: true,
    translation: 'Nav.About',
  },
  {
    title: 'Sell on Depop',
    link: '/sell/',
    external: false,
    translation: 'Nav.SellOnDepop',
  },
  {
    title: 'Depop Affiliates',
    link: '/partners/depop-affiliates',
    external: false,
    translation: 'Nav.DepopAffiliates',
  },
  {
    title: 'Jobs',
    link: FOOTER_LINKS.CAREERS_LINK,
    external: true,
    translation: 'Nav.Jobs',
    rel: 'noopener',
  },
  {
    title: 'News',
    link: FOOTER_LINKS.NEWS_LINK,
    external: true,
    translation: 'Nav.News',
    rel: 'noopener',
  },
  {
    title: 'Support',
    link: HELP_ARTICLES.HELP_HOME,
    asAnchor: true,
    external: true,
    translation: 'Nav.Support',
    rel: 'noopener',
  },
  {
    title: 'Terms',
    link: HELP_ARTICLES.TERMS_OF_SERVICE,
    external: true,
    asAnchor: true,
    translation: 'Nav.Terms',
    rel: 'noopener',
  },
  {
    title: 'Privacy',
    link: HELP_ARTICLES.PRIVACY_POLICY,
    external: true,
    asAnchor: true,
    translation: 'Nav.Privacy',
    rel: 'noopener',
  },
  {
    title: 'Safety',
    link: FOOTER_LINKS.SAFETY_LINK,
    external: true,
    translation: 'Nav.Safety',
    rel: 'noopener',
  },
  {
    title: 'Sitemap',
    link: '/site-map/categories/',
    external: false,
    translation: 'Nav.Sitemaps',
  },
];
